// Raised hands. The Room keeps `handRaisedAt` (epoch ms) on each seat and it
// is absent while the hand is down. Pure, so the rules are tested outside the
// Room and the call screen.

export interface HandCarrier {
  readonly handRaisedAt?: number;
}

/** True when a person's hand just went from down to up. */
export function handWentUp(previous: HandCarrier | undefined, next: HandCarrier): boolean {
  return !previous?.handRaisedAt && !!next.handRaisedAt;
}

/** Whose hand a `handSet` changes, or null when the sender may not change it.
 * Anyone sets their own. The host may lower someone else's, never raise it. */
export function handTarget(
  sender: { readonly id: string; readonly kind: "host" | "guest" },
  message: { readonly raised: boolean; readonly participantId?: string },
): string | null {
  const target = typeof message.participantId === "string" ? message.participantId : sender.id;
  if (target === sender.id) return target;
  return sender.kind === "host" && message.raised !== true ? target : null;
}
